import { useContext, useState } from 'react'
import ModalComponent from '../../Modal'
import ButtonComponent from '../../Button'
import styles from './inner-table.module.scss'
import { useTranslation, Trans } from 'react-i18next'
import { useUpdateSociogramTeacherAccess } from '@BUP/hooks/Sociogram/teachersData/useUpdateTeacherAccess'
import { EventsContext } from '@BUP/contexts/EventsContext'
import { useQueryClient } from '@tanstack/react-query'
import { CurrentTermContext } from '@BUP/contexts/CurrentTermContext'
import { message } from 'antd'

const ShowTeacherResultsButton = ({ survey }) => {
  const { teacherData } = survey
  const { enrollmentId, courses, user } = teacherData
  const teacherName = user.name
  const courseName = courses?.[0]?.name
  const accessState = teacherData?.accessState?.current || false
  const i18n = useTranslation()
  const [stateModal, setStateModal] = useState(false)
  const { events } = useContext(EventsContext)
  const term = useContext(CurrentTermContext)

  const event = events.find(event => event.activityId === survey.sociogram_id.id)
  const queryClient = useQueryClient()

  const { isUpdatingAccess, updateTeacherAccess } = useUpdateSociogramTeacherAccess({
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['sociogramteachers', term.id],
        refetchType: 'all'
      })
      setStateModal(false)

      message.success(
        <Trans
          i18nKey={
          variables?.data?.accessState
            ? 'pages.data.sociogram.activeSociogramEce.resultsTeacherModal.messages.showSuccess'
            : 'pages.data.sociogram.activeSociogramEce.resultsTeacherModal.messages.hideSuccess'
        }
          values={{ teacherName }}
          components={{
            bold: <strong />
          }}
        />
      )
    },
    onError: (err) => {
      message.error(
        i18n.t('common.resources.generic.messages.error')
      )
      console.error(err)
    }
  })

  const handleShowModal = () => {
    setStateModal(true)
  }

  const handleCloseModal = () => {
    setStateModal(false)
  }

  const handleConfirmSurvey = () => {
    if (!event?.id) {
      console.error('eventId not found for survey:', survey)
      return
    }
    updateTeacherAccess({
      enrollmentId,
      accessState: !accessState,
      eventId: event?.id
    })
  }

  return (
    <div
      data-test='cell-wrapper-finish-button'
      className={styles.actions_cell_wrapper}
    >
      <div className={styles.show_modal_button_wrapper}>
        <ButtonComponent
          buttonText={accessState ? `${i18n.t('pages.data.sociogram.activeSociogramEce.resultsTeacherModal.actions.hide')}` : `${i18n.t('pages.data.sociogram.activeSociogramEce.resultsTeacherModal.actions.show')}`}
          colorType='tertiary'
          block
          bold={false}
          onClick={() => handleShowModal(survey)}
          disabled={!teacherData || isUpdatingAccess}
          loading={isUpdatingAccess}
        />
      </div>
      <ModalComponent
        stateModal={stateModal}
        onClickCloseModal={() => {
          handleCloseModal()
        }}
        modalTitle={<>{accessState ? `${i18n.t('pages.data.sociogram.activeSociogramEce.resultsTeacherModal.title.hide')} ${courseName}` : `${i18n.t('pages.data.sociogram.activeSociogramEce.resultsTeacherModal.title.show')} ${courseName}`}</>}
        modalDescription={
          <div className={styles.modal_description_wrapper}>
            <Trans
              i18nKey={accessState ? `${i18n.t('pages.data.sociogram.activeSociogramEce.resultsTeacherModal.description.hide')}` : `${i18n.t('pages.data.sociogram.activeSociogramEce.resultsTeacherModal.description.show')}`}
              values={{ teacherName }}
              components={{ bold: <strong className={styles.teacher_name} /> }}
            />
          </div>
    }
        confirmButtonText={!accessState ? i18n.t('pages.data.sociogram.activeSociogramEce.resultsTeacherModal.actions.confirmShow') : i18n.t('pages.data.sociogram.activeSociogramEce.resultsTeacherModal.actions.confirmHide')}
        onClickConfirm={() => handleConfirmSurvey()}
        loading={isUpdatingAccess}
      />
    </div>
  )
}

export default ShowTeacherResultsButton
